module.exports = __webpack_public_path__ + "static/img/son11.f51cab19.png";